import { AfterViewInit, ApplicationRef, Component, Inject, Input, NgZone, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { NbContextMenuDirective, NbMenuItem, NbMenuService, NbPosition } from '@nebular/theme';
import { Subject, Subscription } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { MenuConfig } from '../../../models/header-model';
import { NavStateService } from './nav-state.service';
import { SubNavComponent } from './sub-nav/sub-nav.component';
import { NbPopoverDirective } from '@nebular/theme';
import { FlatMenuService } from './flat-menu.service';
import { isPlatformBrowser } from '@angular/common';
import { DomReadyService } from '../../services/dom-ready.service';

@Component({
  selector: 'kw-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit,OnChanges,AfterViewInit,OnDestroy {
  @Input() items:NbMenuItem[];
  @Input() mainMenuConfig:MenuConfig;
  menuTag:string;

  host:HTMLElement;
  isMenuSet:boolean = false;

  isSubMenuSet:boolean = false;

  topLevelItems:NbMenuItem[];

  private destroy$ = new Subject<void>();

  subnavComp = SubNavComponent;

  subMenuItems$:Subscription;
  subMenuItems:NbMenuItem[];

  stateMenuItems:NbMenuItem[];

  private hydrationComplete = false;
  private mutationObserver?: MutationObserver;
  private elementCheckInterval?: number;

  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ViewChild(NbContextMenuDirective) contextMenu: NbContextMenuDirective;
  @ViewChild('subMenus', { read: TemplateRef }) templateSubMenu: TemplateRef<any>;

  constructor(private readonly viewRef: ViewContainerRef,
    private menuService:NbMenuService,
    private navState:NavStateService,
    private flatMenu:FlatMenuService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private domReady: DomReadyService,
    private ngZone: NgZone,
    private appRef: ApplicationRef
    ) { 
    this.host = this.viewRef.element.nativeElement;
    /* this.menuService.getSelectedItem('main-menu')
      .pipe(takeUntil(this.destroy$))
      .subscribe( (menuBag) => {
        if(menuBag != null){
          console.log({selectedItem:menuBag});
        }
      }); */
    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuBag) => {
        console.log(menuBag);
        //this.menuItem = menuBag.item.title;
        //this.navState.setSelectItem()
        this.resolveMenuItem(menuBag.item)
        //console.log(menuBag.item.parent);
        //let selectedComponent = this.settings.find(setting => setting.entityName == menuBag.item.queryParams["entityName"]);
        /* if(selectedComponent){
          //console.log(selectedComponent);
          this.windowService.open(WindowContainerComponent, 
            { title: selectedComponent.title,
              context:{"componentConfig":selectedComponent,"state":this.state},
              windowClass: 'window-limited-height'
            }
          );
        } */
      })
  }
  // Add to your component class
  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["mainMenuConfig"]){
      //this.navState.init(JSON.parse(JSON.stringify(this.mainMenuConfig.menuItems)));
      //const stateMenuItems = structuredClone(this.mainMenuConfig.menuItems);
      //Make 3 independent Copies of original;
      const originalItems = this.mainMenuConfig.menuItems;
      //1. Copy 1
      this.stateMenuItems  = JSON.parse(JSON.stringify(originalItems));
      //2. 
      const flateMenuSource = JSON.parse(JSON.stringify(originalItems));
      //this.stateMenuItems  = JSON.parse(JSON.stringify(this.mainMenuConfig.menuItems));
      const flatMenus = this.flatMenu.flattenItems(flateMenuSource);
      //console.log({FlattenedBefore:flatMenus});
      //const topMenuItems = this.flatMenu.makeTopMenuItems(topMenuSrc);
      //console.log(topMenuItems);
      //this.navState.init(this.stateMenuItems);
      this.items = JSON.parse(JSON.stringify(this.mainMenuConfig.menuItems));
      //console.log(this.items);
      this.menuTag = this.mainMenuConfig.menuTag;
      //this.menuItems = this.items;
      //Sanitize items which may include string value booleans by converting strings to boolean for the hidden property
      this.stringToBoolean(this.items);
      this.items.forEach(item => {
        if(item.children != null){
          delete item.children;
        }
      });
      //console.log({FlattenedAfter:flatMenus,StateAftr:this.stateMenuItems});
      this.navState.init(flatMenus)
      this.isMenuSet = true; 
      //this.navState.items$.subscribe(items => console.log(items));
    }
  }

  stringToBoolean(items:NbMenuItem[]):void{
    items.forEach(item => {
      if(item.hidden != undefined){
        let stringHidden = <string><unknown>item.hidden
        switch (stringHidden) {
          case "true":
            item.hidden = true;            
            break;
          case "false":
              item.hidden = false;            
              break;  
          default:
            console.log("What de fok");
            break;
        }
      }
      if(item.children != undefined){
        this.stringToBoolean(item.children);
      }
    })
  }

  ngOnInit(): void {
    this.subMenuItems$ = this.navState.subMenuItems$.pipe(takeUntil(this.destroy$)).subscribe(items => {
      if(items != undefined){
        //this.hasItems = true;
        this.stringToBoolean(items);
        this.subMenuItems = items;
        /* this.subMenuItems.forEach(item => {
          if(item.children != null){
            delete item.children;
          }
        }); */
        this.isSubMenuSet = true;
        //console.log(this.subMenuItems);

      }
    })

  }

  private isActuallyBrowser(): boolean {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
  }

  ngAfterViewInit(): void {
    // SSR Guard: Only run in browser environment
    // SSR Guard: Only run in browser environment
    console.log('AfterViewInit called, checking for menu items...');
    console.log('=== DEBUG INFO ===');
    console.log('PLATFORM_ID:', this.platformId);
    console.log('isPlatformBrowser result:', isPlatformBrowser(this.platformId));
    console.log('typeof window:', typeof window);
    console.log('typeof document:', typeof document);
    //console.log('this.items:', this.items);
    //console.log('this.host:', this.host);
    //if (!this.isBrowser() || this.items == null || this.items == undefined) {
    /* if (!this.isBrowser()) {
      return;
    } */
    /* if (!this.isActuallyBrowser()) {
      console.log("Not actually in browser. Skipping.");
      return;
    } */

    //if (typeof window === 'undefined') return;

    if (this.items && this.host) {
    console.log('Attempting direct DOM manipulation...');
      /* setTimeout(() => {
        console.log('Hydration should be complete, applying transforms...');
        this.tryDirectApproach();
      }); */
      /* this.domReady.run(() => {
        console.log('DOM is ready — safe to manipulate it now.');
        this.tryDirectApproach();
      }); */
      // Option 1: Using the generic whenReady method
      this.domReady.whenReady(
        () => this.tryDirectApproach(),
        {
          debug: true,
          condition: () => this.host.querySelectorAll('ul').length > 0
        }
      ).catch(error => {
        console.error('DOM manipulation failed:', error);
      });
    }
    // Wait for app to be stable (hydration complete) before attempting DOM manipulation
    //console.log("Passed isBrowser check, waiting for app stability...");
    //this.waitForStableApp();

    //More recent stuff
    // Check if elements are already present (hydration case)
    /* const existingMenuEls = this.host?.querySelectorAll('ul');
    if (existingMenuEls && existingMenuEls.length > 0) {
      this.applyMenuStyles(existingMenuEls);
    } else {
      // Elements not yet present, observe for them
      this.observeMenuElements();
    } */
    //Old stuff
    /* if (this.items != null) {
      this.ngZone.runOutsideAngular(() => {
        // Run outside Angular zone to avoid triggering change detection
        requestAnimationFrame(() => {
          const menuEls = this.host.querySelectorAll('ul');
          if (menuEls && menuEls.length > 0) {
            menuEls.forEach((menuEl, i) => {
              menuEl.classList.add('horizontal-menu');
              if (i !== 0) {
                menuEl.style.display = 'flex';
                menuEl.style.flexDirection = 'column';
              }
            });
          }
          this.menuService.collapseAll('main-menu');
        });
      });
    } */
    /* if(this.items != null && this.items != undefined){
      setTimeout(() => {
        console.log(this.host);
        let menuEls = this.host.querySelectorAll('ul');
        if(menuEls != undefined && menuEls.length > 0){
          menuEls.forEach((menuEl,i) => {
            menuEl.classList.add('horizontal-menu');
            if(i != 0){
              menuEl.style.display = "flex";
              menuEl.style.flexDirection = "column";
            }
          })
        }
        this.menuService.collapseAll('main-menu');
      }, 100);
    } */
    
  }
  private tryDirectApproach(): void {
    try {
      const menuEls = this.host.querySelectorAll('ul');
      console.log('Found elements:', menuEls.length);
      const menuArray = menuEls ? Array.from(menuEls) : [];
      if (menuArray.length > 0) {
        menuArray.forEach((menuEl, i) => {
          console.log(`Processing element ${i}:`, menuEl);
          menuEl.classList.add('horizontal-menu');
          console.log('Element classList after:', menuEl.classList.toString());
          if (i !== 0) {
            (menuEl as HTMLElement).style.display = "flex";
            (menuEl as HTMLElement).style.flexDirection = "column";
          }
        });
        this.menuService.collapseAll('main-menu');
        console.log('Styles applied successfully');
      }
    } catch (error) {
      console.error('Direct approach failed:', error);
    }
  }

  private waitForStableApp(): void {
    // Strategy 1: Wait for Angular app to be stable (hydration complete)
    this.appRef.isStable
      .pipe(
        filter(stable => stable),
        take(1)
      )
      .subscribe(() => {
        this.hydrationComplete = true;
        console.log('App is stable, attempting to apply menu styles');
        
        // Try immediate application
        if (this.tryApplyStyles()) {
          return;
        }

        // If not successful, use multiple fallback strategies
        this.useMultipleStrategies();
      });

    // Fallback: If app doesn't stabilize within reasonable time
    setTimeout(() => {
      if (!this.hydrationComplete) {
        console.log('App stability timeout, forcing style application');
        this.hydrationComplete = true;
        this.useMultipleStrategies();
      }
    }, 3000);
  }

  private tryApplyStyles(): boolean {
    if (!this.host) {
      return false;
    }
    console.log('Passed host check, trying to apply styles...');

    const menuEls = this.host.querySelectorAll('ul');
    
    if (menuEls && menuEls.length > 0) {
      console.log(`Found ${menuEls.length} menu elements, applying styles`);
      
      // Apply styles within NgZone to ensure proper change detection
      this.ngZone.run(() => {
        this.applyMenuStyles(menuEls);
      });
      
      return true;
    }

    return false;
  }

  private useMultipleStrategies(): void {
    // Strategy 1: Immediate retry
    if (this.tryApplyStyles()) {
      return;
    }

    // Strategy 2: MutationObserver for dynamic content
    this.setupMutationObserver();

    // Strategy 3: Polling with exponential backoff
    this.startPollingWithBackoff();

    // Strategy 4: Use NgZone to ensure proper change detection
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.ngZone.run(() => {
          this.tryApplyStyles();
        });
      }, 100);
    });
  }

  private setupMutationObserver(): void {
    if (!this.host || typeof MutationObserver === 'undefined') {
      return;
    }

    this.mutationObserver = new MutationObserver((mutations) => {
      let foundElements = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if any added nodes contain our target elements
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as Element;
              const menuEls = element.tagName === 'UL' 
                ? [element] 
                : Array.from(element.querySelectorAll('ul'));
              
              if (menuEls.length > 0) {
                foundElements = true;
              }
            }
          });
        }
      });

      if (foundElements || this.tryApplyStyles()) {
        this.cleanup();
      }
    });

    this.mutationObserver.observe(this.host, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }

  private startPollingWithBackoff(): void {
    let attempts = 0;
    let delay = 50;
    const maxDelay = 500;
    const maxAttempts = 20;

    const poll = () => {
      if (this.tryApplyStyles()) {
        this.cleanup();
        return;
      }

      attempts++;
      if (attempts < maxAttempts) {
        delay = Math.min(delay * 1.2, maxDelay);
        this.elementCheckInterval = window.setTimeout(poll, delay);
      } else {
        console.warn('Max attempts reached, menu elements may not be present');
        this.cleanup();
      }
    };

    this.elementCheckInterval = window.setTimeout(poll, delay);
  }

  private cleanup(): void {
    if (this.elementCheckInterval) {
      clearTimeout(this.elementCheckInterval);
      this.elementCheckInterval = undefined;
    }

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = undefined;
    }
  }

  resolveMenuItem(item:NbMenuItem){
    //NbMenuItem.getParents
    this.navState.setSelectItem(item.data["contentId"]);
    this.popover.show();
    this.popover.rebuild();
 
  }

  private observeMenuElements(): void {
    // Additional safety check for browser environment
    if (!this.host || typeof MutationObserver === 'undefined') {
      return;
    }
  
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const menuEls = this.host.querySelectorAll('ul');
          if (menuEls && menuEls.length > 0) {
            this.applyMenuStyles(menuEls);
            observer.disconnect();
          }
        }
      });
    });
  
    observer.observe(this.host, {
      childList: true,
      subtree: true
    });
  
    // Cleanup observer after reasonable time
    setTimeout(() => observer.disconnect(), 5000);
  }
  private applyMenuStyles(menuEls: NodeListOf<Element>): void {
    menuEls.forEach((menuEl, i) => {
      console.log("ADDING HORIZONTAL MENU CLASS");
      menuEl.classList.add('horizontal-menu');
      if (i !== 0) {
        (menuEl as HTMLElement).style.display = "flex";
        (menuEl as HTMLElement).style.flexDirection = "column";
      }
    });
    this.menuService.collapseAll('main-menu');
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
